




































// @ is an alias to /src
import {
  UserManagementResetPasswordRequest,
  UserManagerService,
} from "@/common/api";
import { Vue, Component } from "vue-property-decorator";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import ResetPasswordComplete from "@/components/auth/resetPasswordComplete.vue";

@Component({
  name: "ResetPassword",
  components: {
    QErrors,
    ResetPasswordComplete,
  },
})
export default class ResetPassword extends Vue {
  public isComplete = false;
  public email = "";
  public isShow = false;
  public form: UserManagementResetPasswordRequest = {
    password: "",
    passwordConfirmation: "",
    token: "",
  };
  public errors = {};

  public switchConfirm(email: string) {
    this.isComplete = true;
    this.email = email;
  }

  public async submit() {
    let response;
    try {
      this.form.token = this.$route.query.token.toString();

      response = await UserManagerService.adminResetPassword(this.form);
    } catch (error) {
      response = error.body;
      this.errors = response.errors;
    }

    if (response.errors && response.errors.token) {
      return this.$router.push({
        name: "admin.resetPassword.expired",
      });
    }

    if (response.status == "success") {
      qNotify.success({
        text: response.message,
      });

      (this.$refs.ResetPasswordCompletePopUp as ResetPasswordComplete).show();
    } else {
      qNotify.error({
        text: response.message,
      });
    }
  }
}
